import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_AmerigroupOutpatientTreatmentRequestForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_AmerigroupOutpatientTreatmentRequestForm' className='file-pdf-document'>
            <div className='file-template'>

                
                <p className='w-750'><center><span className='eleHeader'>Behavioral Health outpatient treatment report form</span></center></p>

                <p className='w-750'>Submit via website at providers.amerigroup.com/LA or fax to 1-866-877-5229</p>

                <p className='w-750'><h3>Provider information</h3></p>
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider name:</span>
                            <input type='text' id='txtProviderName' name='txtProviderName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Tax ID:</span>
                            <input type='text' id='txtTaxId' name='txtTaxId' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax:</span>
                            <input type='text' id='txtFax' name='txtFax' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>PCP name:</span>
                            <input type='text' id='txtPcpName' name='txtPcpName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>PCP NPI:</span>
                            <input type='text' id='txtPcpNpi' name='txtPcpNpi' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of other behavioral health providers:</span>
                            <input type='text' id='txtNameOfOtherBehavioralHealthProviders' name='txtNameOfOtherBehavioralHealthProviders' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DSM-5/ICD-10 diagnoses</span>
                            <input type='text' id='txtDiagnoses' name='txtDiagnoses' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Medications</h3></p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Current medications</span>
                            <span className='small'>(indicate changes since last report):</span>
                        </td>
                        <td className='w-250'><span className='eleHeader'>Dosage:</span></td>
                        <td className='w-250'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input id='txtCurrentMedication_1' name='txtCurrentMedication_1' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDosage_1' name='txtDosage_1' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtFrequency_1' name='txtFrequency_1' type='text' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input id='txtCurrentMedication_2' name='txtCurrentMedication_2' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDosage_2' name='txtDosage_2' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtFrequency_2' name='txtFrequency_2' type='text' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input id='txtCurrentMedication_3' name='txtCurrentMedication_3' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDosage_3' name='txtDosage_3' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtFrequency_3' name='txtFrequency_3' type='text' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input id='txtCurrentMedication_4' name='txtCurrentMedication_4' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDosage_4' name='txtDosage_4' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtFrequency_4' name='txtFrequency_4' type='text' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h3>Current risk factors:</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicide:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_1' name='cbSuicidal_1' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_2' name='cbSuicidal_2' className='add-only' value='Ideation' /> Ideation</td>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_3' name='cbSuicidal_3' className='add-only' value='IntentWithoutMeans' /> Intent without means </td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_4' name='cbSuicidal_4' className='add-only' value='IntentWithMeans' /> Intent with means </td>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_5' name='cbSuicidal_5' className='add-only' value='ContractedNotHarmself' />  Contracted not to harm self</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Homicide:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_1' name='cbHomicidal_1' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_2' name='cbHomicidal_2' className='add-only' value='Ideation' /> Ideation</td>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_3' name='cbHomicidal_3' className='add-only' value='IntentWithoutMeans' /> Intent without means </td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_4' name='cbHomicidal_4' className='add-only' value='Intent with means' /> Intent with means </td>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_5' name='cbHomicidal_5' className='add-only' value='ContractedNotHarmOthers' />  Contracted not to harm others</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Physical or sexual abuse or child/elder neglect:</span>
                            <input type='radio' id='rbYes_1' name='rbSafetyAbuse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_1' name='rbSafetyAbuse' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>If “YES” patient is: </span>
                            <input type='checkbox' id='cbVictim' name='cbVictim' className='add-only' value='Victim' /> Victim &nbsp;
                            <input type='checkbox' id='cbPerpetrator' name='cbPerpetrator' className='add-only' value='Perpetrator' /> Perpetrator &nbsp;
                            <input type='checkbox' id='cbBoth' name='cbBoth' className='add-only' value='Both' /> Both &nbsp;
                            <input type='checkbox' id='cbNeither' name='cbNeither' className='add-only' value='Neither' /> Neither,
                            but abuse exists in family
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Abuse or neglect involves a child or elder: </span>
                            <input type='radio' id='rbYes_2' name='rbAbuseNeglect' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_2' name='rbAbuseNeglect' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Abuse has been legally reported: </span>
                            <input type='radio' id='rbYes_3' name='rbLegallyReported' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_3' name='rbLegallyReported' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Symptoms that are the focus of current treatment</span>
                    <textarea id='txtSymptoms' name='txtSymptoms' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Progress since last review</span>
                    <textarea id='txtProgress' name='txtProgress' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Functional impairments/strengths</span>
                    <span className='small'>(including interpersonal relations, personal hygiene, work/school)</span>
                    <textarea id='txtFunctionalImpairments' name='txtFunctionalImpairments' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe recovery environment</span>
                    <span className='small'>(including support system, level of stress)</span>
                    <textarea id='txtDescribeRecovery' name='txtDescribeRecovery' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Engagement/level of active participation in treatment</span>
                    <textarea id='txtEngagement' name='txtEngagement' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Housing</span>
                    <textarea id='txtHousing' name='txtHousing' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Co-occurring medical/physical illness</span>
                    <textarea id='txtPhysicalIllness' name='txtPhysicalIllness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Family history of mental illness or substance abuse</span>
                    <textarea id='txtMentalIllness' name='txtMentalIllness' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Patient's treatment history including all levels of care</h3></p>

                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Level of care</span></td>
                        <td className='w-400'><span className='eleHeader'>Number of distinct episodes/sessions of:</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last episode/ sessions:</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><span>Outpatient Psych</span></td>
                        <td className='w-400'><input type='text' id='txtDistinctEpisodes_1' name='txtDistinctEpisodes_1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtLastEpisode_1' name='txtLastEpisode_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><span>Outpatient-Substance abuse</span></td>
                        <td className='w-400'><input type='text' id='txtDistinctEpisodes_2' name='txtDistinctEpisodes_2' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtLastEpisode_2' name='txtLastEpisode_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><span>RTC-substance abuse</span></td>
                        <td className='w-400'><input type='text' id='txtDistinctEpisodes_3' name='txtDistinctEpisodes_3' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtLastEpisode_3' name='txtLastEpisode_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><span>Inpatient-Psych</span></td>
                        <td className='w-400'><input type='text' id='txtDistinctEpisodes_4' name='txtDistinctEpisodes_4' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtLastEpisode_4' name='txtLastEpisode_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><span>Inpatient-Substance abuse</span></td>
                        <td className='w-400'><input type='text' id='txtDistinctEpisodes_5' name='txtDistinctEpisodes_5' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtLastEpisode_5' name='txtLastEpisode_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><span>RTC-psych</span></td>
                        <td className='w-400'><input type='text' id='txtDistinctEpisodes_6' name='txtDistinctEpisodes_6' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtLastEpisode_6' name='txtLastEpisode_6' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h3>Requested service authorization</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Procedure code:</span>
                            <input type='text' id='txtProcedureCode_1' name='txtProcedureCode_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_1' name='txtNumberOfUnits_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency:</span>
                            <input type='text' id='txtFreq_1' name='txtFreq_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested start date:</span>
                            <input type='date' id='txtRequestedStartDate_1' name='txtRequestedStartDate_1' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Estimated # units to complete treatment:</span>
                            <input type='text' id='txtEstimatedUnits_1' name='txtEstimatedUnits_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Procedure code:</span>
                            <input type='text' id='txtProcedureCode_2' name='txtProcedureCode_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_2' name='txtNumberOfUnits_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency:</span>
                            <input type='text' id='txtFreq_2' name='txtFreq_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested start date:</span>
                            <input type='date' id='txtRequestedStartDate_2' name='txtRequestedStartDate_2' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Estimated # units to complete treatment:</span>
                            <input type='text' id='txtEstimatedUnits_2' name='txtEstimatedUnits_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Procedure code:</span>
                            <input type='text' id='txtProcedureCode_3' name='txtProcedureCode_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_3' name='txtNumberOfUnits_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency:</span>
                            <input type='text' id='txtFreq_3' name='txtFreq_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested start date:</span>
                            <input type='date' id='txtRequestedStartDate_3' name='txtRequestedStartDate_3' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Estimated # units to complete treatment:</span>
                            <input type='text' id='txtEstimatedUnits_3' name='txtEstimatedUnits_3' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Treatment Goals for each type of service (specify) with expected dates to achieve them</span>
                    <textarea id='txtTreatmentGoals' name='txtTreatmentGoals' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>MEASURED Objective outcome criteria by which goal achievement is measured</span>
                    <textarea id='txtMeasuredObjective' name='txtMeasuredObjective' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Discharge plan and estimated discharge date</span>
                    <textarea id='txtDischargePlan' name='txtDischargePlan' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Expected outcome and prognosis</span></p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbExpectedOutcomeAndPrognosis_1' name='cbExpectedOutcomeAndPrognosis_1' className='add-only' value='1' /> Return to normal functioning</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbExpectedOutcomeAndPrognosis_2' name='cbExpectedOutcomeAndPrognosis_2' className='add-only' value='2' /> Expect improvement, anticipate less than normal functioning</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbExpectedOutcomeAndPrognosis_3' name='cbExpectedOutcomeAndPrognosis_3' className='add-only' value='3' /> Relieve acute symptoms, return to baseline functioning</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbExpectedOutcomeAndPrognosis_4' name='cbExpectedOutcomeAndPrognosis_4' className='add-only' value='4' /> Maintain current status, prevent deterioration</td>
                    </tr>
                </table>

                <p className='w-750'><hr /></p>

                <p className='w-750'><b>Psychological/Neuropsychological Testing requests require a separate form. </b></p>
                <p className='w-750'><h3>Treatment plan coordination</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I have requested permission from the member/member's parent or guardian to release information to the PCP</span>
                            <input type='radio' id='rbYes_4' name='rbRequestedPermission' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_4' name='rbRequestedPermission' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            If no, rationale why this is inappropriate: &nbsp;
                            <input id='txtInappropriate' name='txtInappropriate' type='text' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Treatment plan was discussed with and agreed upon by the member/member's parent or guardian.</span>
                            <input type='radio' id='rbYes_5' name='rbTreatmentPlan' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_5' name='rbTreatmentPlan' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                
                <p className='w-750'><b>Please attach summary sheets of ASAM, LOCUS, CASII or other applicable assessments</b></p>

                <table>
                    <tr>
                        <td className='signature w-350'>&nbsp; </td>
                        <td className='signature w-350'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-350'> Provider's signature </td>
                        <td className='small w-350'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    Disclaimer: Authorization indicates that Amerigroup Louisiana, Inc. determined medical necessity has been met for
                    the requested service(s) but does not guarantee payment. Payment is contingent upon the eligibility and benefit
                    limitations at the time services are rendered. <br /><br />
                    Important Note: You are not permitted to use or disclose Protected Health Information about individuals who you
                    are not currently treating or are not enrolled to your practice. This applies to Protected Health Information
                    accessible in any online tool, sent in any medium including mail, email, fax or other electronic transmission.
                </p>


            </div>
        </form >

    )
}











